/* eslint-disable */
export default {
  flipHeader: 'Transferir chamada para...',
  flip: 'Transferência dinâmica',
  complete: 'Transferência dinâmica concluída',
} as const;

// @key: @#@"flipHeader"@#@ @source: @#@"Flip Call to..."@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"complete"@#@ @source: @#@"Complete Flip"@#@
